function r(n,i){return new Promise(e=>{function t(o){o.target===n&&(n.removeEventListener(i,t),e())}n.addEventListener(i,t)})}export{r as a};
